<template lang="pug">
.circles.rotate-45(
  :class="twMerge('absolute w-[60vmin] h-[60vmin] top-[10vh] -z-1 pointer-events-none', classes.root)"
  ref="el"
)
  .circle(:class="['left-[0%]', classes.bg]")
  .circle(:class="['left-[0%] top-[33.33%]', classes.bg]")
  .circle(:class="['left-[0%] top-[16.66%]', classes.bg]")
</template>

<script setup>
// eslint-disable-next-line no-unused-vars
import { twMerge } from '../lib/mergeStyles';
import { onMounted, ref, computed } from 'vue';
import gsap from 'gsap';
console.log(1);

const el = ref(null);

const props = defineProps({ screen: { type: Object, required: true } });

// eslint-disable-next-line no-unused-vars
const classes = computed(() => {
  const fullClass = props.screen?.circles || [];
  const arr = fullClass.split(' ');

  const i = arr.findIndex(c => c.startsWith('bg-'));

  if (i >= 0) {
    arr.splice(i, 1);
  }

  const bg = [twMerge('bg-primary-400/20', arr[i])];
  const root = arr.join(' ');

  return { root, bg };
});
</script>

<style scoped>
.circle {
  @apply absolute inline-block h-[40vmin] w-[40vmin] rounded-[999px];

  &:nth-child(3) {
    left: 33.33%;
  }
}

.circles {
  transform-origin: 46% 50%;
  /* border: 4px solid red;
  border-color: red lime lime; */
}
</style>
